var map = {
	"./gallery_00.jpg": 1844,
	"./gallery_01.jpg": 1845,
	"./gallery_02.jpg": 1846,
	"./gallery_03.jpg": 1847,
	"./gallery_04.jpg": 1848,
	"./gallery_05.jpg": 1849,
	"./gallery_06.jpg": 1850,
	"./gallery_07.jpg": 1851,
	"./gallery_08.jpg": 1852,
	"./gallery_09.jpg": 1853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1843;